import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				width: "100%",
				height: `calc(100vh - 130px)`,
				position: "relative"
			},
			rootImages: {
				transform: "translate(0, -50%)",
				width: "100%",
				top: "40%",
				position: "absolute"
			},
			image: {
				maxWidth: 200
			},
			text: {
				color: theme.palette.grey[700],
				fontSize: 14,
				marginTop: 5
			}
		}),
	{
		name: "NonNoti",
		index: 1
	}
);

export default useStyles;
